import { Box, Tab, Tabs, useTheme } from '@mui/material'
import useScreenWidth from '../../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../../shared/styles/FormsStyles'

interface TabsSectionProps {
  currentTab: number
  onTabChange: (event: any, newValue: number) => void
  isAdminUser: boolean
  seminarlesson_selected: any
  showFormSeminarLesson: boolean
  seminarLessonsLength: number
  t: (key: string) => string
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const TabsSection = ({
  currentTab,
  onTabChange,
  isAdminUser,
  seminarlesson_selected,
  showFormSeminarLesson,
  seminarLessonsLength,
  t
}: TabsSectionProps) => {
  const theme = useTheme()
  const isMobile = useScreenWidth(700)
  const isLaptop = useScreenWidth(1024)
  const formClasses = formsStyles(theme)

  if (!isAdminUser) return null

  return (
    <Box
      display="flex"
      marginTop={seminarlesson_selected != null && !showFormSeminarLesson ? '-16px' : seminarLessonsLength > 1 ? 0 : undefined}
      marginBottom={seminarlesson_selected != null && !showFormSeminarLesson ? undefined : seminarLessonsLength > 1 ? '-32px' : undefined}
    >
      <Box maxWidth={isLaptop ? 500 : 960} width="100%" marginX="auto" p={isMobile ? 1 : 3} pb={0}>
        <Tabs
          value={currentTab}
          indicatorColor="secondary"
          textColor="primary"
          sx={formClasses.tapForm}
          onChange={onTabChange}
          aria-label="disabled tabs example"
        >
          <Tab data-testid="tab-content" label={t('content')} {...a11yProps(0)} />
          <Tab data-testid="tab-registered" label={t('registered')} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <Box width="361px" />
    </Box>
  )
}

export default TabsSection
